import { useQuery } from '@tanstack/react-query';
import { getValueSavings } from '../value.api';

export function useValueSavings(gln: string) {
  return useQuery({
    queryKey: ['value', 'savings', gln],
    queryFn: () => getValueSavings(gln),
    enabled: !!gln,
    staleTime: 5 * 60 * 1000,
  });
}
